import { Icon } from 'shared/components';
import * as bi from 'react-bootstrap-icons';
import './style.scss';
import { Flex } from 'components';

function NoneBackTrips() {
  return (
    <Flex
      className='no-tickets-Lajs1'
      gap={5}
      alignItems='center'
    >
      <bi.X />
      <span>Нет обратных билетов на эту дату</span>
    </Flex>
  );
}

export default NoneBackTrips;
